import React from "react";

export default () => {
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData("application/reactflow", nodeType);
    event.dataTransfer.effectAllowed = "move";
  };

  return (
    <aside
      style={{ position: "relative", marginTop: "3em", background: "#000" }}
    >
      <div className="d-flex flex-column" style={{ paddingRight: "1rem" }}>
        <div
          className="dndnode custom"
          onDragStart={(event) => onDragStart(event, "PlatFormNode")}
          draggable
        >
          <i className="	fa fa-upload" style={{ paddingRight: "1rem" }}></i>
          PLATFORM
        </div>
        <div
          className="dndnode custom"
          onDragStart={(event) => onDragStart(event, "FilterNode")}
          draggable
        >
          <i className="	fa fa-filter" style={{ paddingRight: "1rem" }}></i>
          FILTER
        </div>
        <div
          className="dndnode custom"
          onDragStart={(event) => onDragStart(event, "AnonNode")}
          draggable
        >
          <i className="	fa fa-gavel" style={{ paddingRight: "1rem" }}></i>
          ANON PROTOCOL
        </div>
        <div
          className="dndnode custom"
          onDragStart={(event) => onDragStart(event, "PACSRecNode")}
          draggable
        >
          <i className="	fa fa-arrow-up" style={{ paddingRight: "1rem" }}></i>
          PACS RECIPIENTS
        </div>
        <div
          className="dndnode custom"
          onDragStart={(event) => onDragStart(event, "PACSDestNode")}
          draggable
        >
          <i className="	fa fa-arrow-down" style={{ paddingRight: "1rem" }}></i>
          PACS DESTINATION
        </div>
        <div
          className="dndnode custom"
          onDragStart={(event) => onDragStart(event, "QRConfigNode")}
          draggable
        >
          <i className="	fa fa-gear" style={{ paddingRight: "1rem" }}></i>
          QR CONFIG
        </div>
        <div
          className="dndnode custom"
          onDragStart={(event) => onDragStart(event, "PushBackNode")}
          draggable
        >
          <i className="	fa fa-arrows-v" style={{ paddingRight: "1rem" }}></i>
          NODE PUSH-BACK
        </div>
        <div
          className="dndnode custom"
          onDragStart={(event) => onDragStart(event, "HL7SenderNode")}
          draggable
        >
          <i className="	fa fa-arrows-h" style={{ paddingRight: "1rem" }}></i>
          HL7 SENDER
        </div>
        <div
          className="dndnode custom"
          onDragStart={(event) => onDragStart(event, "HL7FiltersNode")}
          draggable
        >
          <i className="	fa fa-filter" style={{ paddingRight: "1rem" }}></i>
          HL7 FILTER
        </div>
        <div
          className="dndnode custom"
          onDragStart={(event) => onDragStart(event, "HL7ConfigsNode")}
          draggable
        >
          <i className="	 fa fa-gears" style={{ paddingRight: "1rem" }}></i>
          HL7 CONFIGS
        </div>
      </div>
    </aside>
  );
};
